(() => {
  if (window.saiyisPartsNavigation) {
    window.saiyisPartsNavigation.init(document);
    return;
  }
  const hydrateImages = scope => {
    if (!scope) return;
    scope.querySelectorAll('template[data-sp-deferred-image]:not([data-sp-leaf-image])').forEach(template => {
      template.before(template.content.cloneNode(true));
      template.remove();
    });
  };
  const hydrateLeafImages = scope => {
    scope.querySelectorAll('template[data-sp-leaf-image]').forEach(template => {
      template.before(template.content.cloneNode(true));
      template.remove();
    });
  };
  const fillBrandRequest = () => {
    const brand = new URLSearchParams(window.location.search).get('parts_brand');
    if (!brand || !window.location.pathname.replace(/\/+$/, '').endsWith('/pages/contact')) return;
    const source = [...document.querySelectorAll('[data-sp-inquiry-brand]')].find(link => link.dataset.spInquiryBrand === brand);
    const field = document.querySelector('form[action*="/contact"] textarea[name="contact[body]"]');
    if (source && field && !field.value.trim()) {
      field.value = source.dataset.spInquiryMessage;
      field.dispatchEvent(new Event('input', {bubbles:true}));
    }
  };
  const init = scope => {
    scope.querySelectorAll('[data-sp-drill]').forEach(root => {
      if (root.dataset.drillReady) return;
      root.dataset.drillReady = 'true';
      const summary = root.querySelector(':scope > summary');
      const panel = root.querySelector(':scope > .sp-drill-panel');
      const back = panel?.querySelector(':scope > .sp-stage-header > [data-sp-back]');
      if (!summary || !panel || !back) return;
      const close = () => { root.open = false; summary.focus(); };
      back.addEventListener('click', close);
      root.addEventListener('toggle', e => {
        if (e.target !== root) return;
        summary.setAttribute('aria-expanded', String(root.open));
        if (root.open) {
          hydrateImages(panel.querySelector(':scope > .sp-stage-body > .sp-subgroups'));
          requestAnimationFrame(() => { if (root.open) back.focus({preventScroll:true}); });
        }
      });
      root.addEventListener('keydown', e => {
        if (e.key === 'Escape' && root.open) { e.preventDefault(); e.stopPropagation(); close(); }
        if (e.key === 'Tab' && root.open && !panel.querySelector('[data-sp-drill][open]')) {
          const items = [...panel.querySelectorAll('button, a[href], summary, [tabindex="0"]')].filter(el => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
          const edge = e.shiftKey ? items[0] : items[items.length - 1];
          if (edge && (document.activeElement === edge || !panel.contains(document.activeElement))) {
            e.preventDefault(); e.stopPropagation(); (e.shiftKey ? items[items.length - 1] : items[0]).focus();
          }
        }
      });
    });
    scope.querySelectorAll('[data-sp-responsive]').forEach(root => {
      if (root.dataset.responsiveReady) return;
      root.dataset.responsiveReady = 'true';
      const mobile = window.matchMedia('(max-width: 749px)');
      const summary = root.querySelector(':scope > summary');
      const update = () => {
        root.open = !mobile.matches;
        if (summary) summary.tabIndex = mobile.matches ? 0 : -1;
      };
      update();
      mobile.addEventListener('change', update);
      summary?.addEventListener('click', e => { if (!mobile.matches) e.preventDefault(); });
    });
    scope.querySelectorAll('[data-sp-category-group], [data-sp-system]').forEach(root => {
      if (root.dataset.accordionReady) return;
      root.dataset.accordionReady = 'true';
      const summary = root.querySelector(':scope > summary');
      const sync = () => summary?.setAttribute('aria-expanded', String(root.open));
      sync();
      root.addEventListener('toggle', e => {
        if (e.target !== root) return;
        sync();
        if (!root.open || (root.hasAttribute('data-sp-responsive') && window.matchMedia('(min-width: 750px)').matches)) return;
        [...root.parentElement.children].filter(other => other !== root && other.tagName === 'DETAILS').forEach(other => { other.open = false; });
        hydrateImages(root);
        if (root.hasAttribute('data-sp-category-group')) hydrateLeafImages(root);
      });
    });
    scope.querySelectorAll('[data-sp-directory]').forEach(root => {
      if (root.dataset.imageReady) return;
      root.dataset.imageReady = 'true';
      const desktop = window.matchMedia('(min-width: 750px)');
      const loadDesktop = () => {
        if (desktop.matches) hydrateImages(root.querySelector('.sp-directory-desktop') || root);
        else if (root.querySelector('.sp-directory-mobile')) hydrateImages(root.querySelector('.sp-directory-mobile'));
      };
      loadDesktop();
      desktop.addEventListener('change', loadDesktop);
      const button = root.querySelector('[data-sp-expand]');
      if (!button) return;
      root.dataset.mobileEnhanced = 'true';
      button.hidden = false;
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(expanded));
        root.classList.toggle('sp-expanded', expanded);
        button.textContent = expanded ? button.dataset.collapseLabel : button.dataset.expandLabel;
        if (expanded) hydrateImages(root);
        if (!expanded) root.querySelector('.sp-card').scrollIntoView({block:'start', behavior:'instant'});
      });
    });
    scope.querySelectorAll('.sp-mobile').forEach(root => {
      if (root.dataset.imageReady) return;
      root.dataset.imageReady = 'true';
      root.addEventListener('toggle', () => {
        if (!root.open) return;
        root.querySelectorAll('details[open]').forEach(hydrateImages);
      }, true);
    });
    scope.querySelectorAll('[data-sp-navigation]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const summary = root.querySelector(':scope > summary');
      const panel = root.querySelector(':scope > .sp-panel');
      if (!summary || !panel) return;
      const tabs = [...root.querySelectorAll('.sp-tab')];
      const panes = [...root.querySelectorAll('.sp-pane')];
      let timer;
      let hoverTimer;
      const align = () => {
        if (!root.open) return;
        const width = panel.getBoundingClientRect().width;
        const viewportWidth = document.documentElement.clientWidth;
        const rootLeft = root.getBoundingClientRect().left;
        const panelLeft = root.classList.contains('sp-compact-nav') ? Math.max(16,Math.min(rootLeft,viewportWidth-width-16)) : Math.max(16,(viewportWidth-width)/2);
        panel.style.left = `${panelLeft-rootLeft}px`;
      };
      const activate = tab => {
        tabs.forEach(t => { const selected = t === tab; t.setAttribute('aria-selected', String(selected)); t.tabIndex = selected ? 0 : -1; });
        panes.forEach(p => { p.hidden = p.id !== tab.getAttribute('aria-controls'); });
        if (root.open) hydrateImages(root.querySelector('.sp-pane:not([hidden])'));
      };
      root.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', String(root.open));
        align();
        if (root.open) {
          document.querySelectorAll('[data-sp-navigation]').forEach(other => { if (other!==root) other.open=false; });
          hydrateImages(panes.length ? root.querySelector('.sp-pane:not([hidden])') : panel);
        }
      });
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', e => {
          let next;
          if (e.key === 'ArrowDown' || e.key === 'ArrowRight') next = (i + 1) % tabs.length;
          if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
          if (e.key === 'Home') next = 0;
          if (e.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { e.preventDefault(); activate(tabs[next]); tabs[next].focus(); }
        });
      });
      root.addEventListener('keydown', e => { if (e.key === 'Escape') { e.preventDefault(); clearTimeout(hoverTimer); clearTimeout(timer); root.open = false; summary.focus(); } });
      document.addEventListener('click', e => { if (!root.contains(e.target)) root.open = false; });
      summary.addEventListener('pointerdown', () => clearTimeout(hoverTimer));
      root.addEventListener('pointerenter', e => { if (e.pointerType !== 'mouse') return; clearTimeout(timer); hoverTimer = setTimeout(() => { root.open = true; }, 140); });
      root.addEventListener('pointerleave', e => { if (e.pointerType !== 'mouse') return; clearTimeout(hoverTimer); timer = setTimeout(() => { if (!root.contains(document.activeElement)) root.open = false; }, 240); });
      window.addEventListener('resize', align, {passive:true});
    });
    scope.querySelectorAll('.sp-mobile-nav').forEach(drawer => {
      if (drawer.dataset.spReady) return;
      drawer.dataset.spReady = 'true';
      const root = drawer.querySelector(':scope > details');
      const summary = root?.querySelector(':scope > summary');
      if (!root || !summary) return;
      const main = document.querySelector('#MainContent');
      const initiallyInert = main?.inert;
      const close = () => {
        if (typeof drawer.close === 'function') drawer.close();
        else root.open = false;
        summary.focus({preventScroll:true});
      };
      drawer.querySelectorAll('[data-sp-close]').forEach(button => button.addEventListener('click', close));
      root.addEventListener('toggle', e => {
        if (e.target !== root) return;
        if (main) main.inert = root.open || initiallyInert;
      });
      root.addEventListener('keydown', e => {
        if (e.key === 'Escape' && root.open) {
          e.preventDefault(); e.stopPropagation(); close();
        }
        if (e.key === 'Tab' && root.open && !root.querySelector('[data-sp-drill][open]')) {
          const items = [...root.querySelectorAll('button, a[href], summary, [tabindex="0"]')].filter(el => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
          const edge = e.shiftKey ? items[0] : items[items.length - 1];
          if (edge && document.activeElement === edge) {
            e.preventDefault(); (e.shiftKey ? items[items.length - 1] : items[0]).focus();
          }
        }
      });
    });

    fillBrandRequest();
  };
  window.saiyisPartsNavigation = {init};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once:true});
  else init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
